var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeerLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 187,
    viewBox: "0 0 217 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.375 159.75C81.375 159.75 87.375 157.958 93.375 154.375L97 161.875C90 166.292 82.5 168.5 74.5 168.5C66.5833 168.5 60.2917 166 55.625 161C50.9583 155.917 48.625 148.625 48.625 139.125C48.625 129.625 51.0417 122.167 55.875 116.75C60.7083 111.25 67.125 108.5 75.125 108.5C82.375 108.5 88.0833 110.75 92.25 115.25C94 117.083 95.4583 119.75 96.625 123.25C97.875 126.75 98.5 130.875 98.5 135.625L94.625 140H59.25C59.5 153.167 64.875 159.75 75.375 159.75ZM88 132.125C88 127.458 86.7917 123.708 84.375 120.875C81.9583 118.042 78.75 116.625 74.75 116.625C70.8333 116.625 67.5 118.042 64.75 120.875C62 123.625 60.3333 127.375 59.75 132.125H88ZM134.457 159.75C140.457 159.75 146.457 157.958 152.457 154.375L156.082 161.875C149.082 166.292 141.582 168.5 133.582 168.5C125.665 168.5 119.374 166 114.707 161C110.04 155.917 107.707 148.625 107.707 139.125C107.707 129.625 110.124 122.167 114.957 116.75C119.79 111.25 126.207 108.5 134.207 108.5C141.457 108.5 147.165 110.75 151.332 115.25C153.082 117.083 154.54 119.75 155.707 123.25C156.957 126.75 157.582 130.875 157.582 135.625L153.707 140H118.332C118.582 153.167 123.957 159.75 134.457 159.75ZM147.082 132.125C147.082 127.458 145.874 123.708 143.457 120.875C141.04 118.042 137.832 116.625 133.832 116.625C129.915 116.625 126.582 118.042 123.832 120.875C121.082 123.625 119.415 127.375 118.832 132.125H147.082ZM170.664 110H177.414L180.539 120H181.039C185.622 114.083 191.914 110.5 199.914 109.25L201.039 119.125C197.122 119.375 193.331 120.375 189.664 122.125C185.997 123.875 183.206 126.208 181.289 129.125V167H170.664V110Z",
    fill: "#2B3D40"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.375 157.75C76.375 157.75 82.375 155.958 88.375 152.375L92 159.875C85 164.292 77.5 166.5 69.5 166.5C61.5833 166.5 55.2917 164 50.625 159C45.9583 153.917 43.625 146.625 43.625 137.125C43.625 127.625 46.0417 120.167 50.875 114.75C55.7083 109.25 62.125 106.5 70.125 106.5C77.375 106.5 83.0833 108.75 87.25 113.25C89 115.083 90.4583 117.75 91.625 121.25C92.875 124.75 93.5 128.875 93.5 133.625L89.625 138H54.25C54.5 151.167 59.875 157.75 70.375 157.75ZM83 130.125C83 125.458 81.7917 121.708 79.375 118.875C76.9583 116.042 73.75 114.625 69.75 114.625C65.8333 114.625 62.5 116.042 59.75 118.875C57 121.625 55.3333 125.375 54.75 130.125H83ZM129.457 157.75C135.457 157.75 141.457 155.958 147.457 152.375L151.082 159.875C144.082 164.292 136.582 166.5 128.582 166.5C120.665 166.5 114.374 164 109.707 159C105.04 153.917 102.707 146.625 102.707 137.125C102.707 127.625 105.124 120.167 109.957 114.75C114.79 109.25 121.207 106.5 129.207 106.5C136.457 106.5 142.165 108.75 146.332 113.25C148.082 115.083 149.54 117.75 150.707 121.25C151.957 124.75 152.582 128.875 152.582 133.625L148.707 138H113.332C113.582 151.167 118.957 157.75 129.457 157.75ZM142.082 130.125C142.082 125.458 140.874 121.708 138.457 118.875C136.04 116.042 132.832 114.625 128.832 114.625C124.915 114.625 121.582 116.042 118.832 118.875C116.082 121.625 114.415 125.375 113.832 130.125H142.082ZM165.664 108H172.414L175.539 118H176.039C180.622 112.083 186.914 108.5 194.914 107.25L196.039 117.125C192.122 117.375 188.331 118.375 184.664 120.125C180.997 121.875 178.206 124.208 176.289 127.125V165H165.664V108Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19.5V0L55 15.25L102 30.5V49L84.5 43.5L8 19.5Z",
    fill: "#BA6560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 55V43.5L102 49V65L64.75 79L27.5 93L8 101V84L84.5 55Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 167.5H8V101L27.5 93L29 167.5Z",
    fill: "url(#paint2_linear_0_1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 23.625,
    y: 86.5,
    width: 192.414,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 0,
    y: 0,
    width: 102,
    height: 175.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 253.465,
    y1: 71.875,
    x2: 253.465,
    y2: 133.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA6560",
    stopOpacity: 0.701961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 91,
    y1: 53.5,
    x2: 93,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC8670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 26.5,
    y1: 101,
    x2: 20.7599,
    y2: 83.5847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7399B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703141,
    stopColor: "#282828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerLogoFull);
export default __webpack_public_path__ + "static/media/Peer_Logo_Full.734a6e16fb7a3ca166c717ee47f5e531.svg";
export { ForwardRef as ReactComponent };